import { useGetCurrentEmployeesQuery } from "types/generated/operations";
import { getProspectUuid } from "utils/idHelpers";
import CurrentEmployees from "./CurrentEmployees";
import CurrentEmployeesUpsell from "./CurrentEmployeeUpsell";
import Loader from "uicomponents/Loader";
import ErrorPage from "uicomponents/Error";
import { getAppType } from "utils/helper";
import { TotalDependentContextProvider } from "./TotalDependentContext";

const CurrentEmployeesModel = (): JSX.Element => {
  const appType = getAppType();
  const { data, error, loading } = useGetCurrentEmployeesQuery({
    variables: { uuid: getProspectUuid(), appType },
    fetchPolicy: "no-cache",
  });

  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <ErrorPage />;
  }
  return (
    <>
      {appType === "HEALTH_INSURANCE" ? (
        <CurrentEmployees data={data?.prospect} />
      ) : (
        <TotalDependentContextProvider>
          <CurrentEmployeesUpsell data={data?.prospect} />
        </TotalDependentContextProvider>
      )}
    </>
  );
};

export default CurrentEmployeesModel;
